var map = {
	"./Stamback in Time v16.pdf": "f87a",
	"./faces/ed-sheeran.png": "1f15",
	"./faces/emily-blunt.png": "add7",
	"./faces/king-george.png": "aac4",
	"./faces/marilyn-monroe.png": "8e80",
	"./faces/nye-bevan.png": "cf9e",
	"./faces/stormzy.png": "1308",
	"./faces/street-panel": "349b",
	"./faces/winston-churchill.png": "0b6a",
	"./heritage-logo.png": "5fa1",
	"./london-met-archive-logo.png": "3bf1",
	"./scene/cinema-sign.png": "621e",
	"./scene/cinema_curtains_3.png": "7bbf",
	"./scene/cinema_seats.png": "84ff",
	"./scene/city_bgbuildings.png": "3a8b",
	"./scene/city_main.png": "ec0f",
	"./scene/city_main_b.png": "a430",
	"./scene/city_sky.png": "cee8",
	"./scene/city_trees.png": "5d8e",
	"./scene/hospital_front.png": "3db6",
	"./scene/hospital_main_with_shad_and_floor.png": "6b3a",
	"./scene/hospital_wall_2.png": "1fa9",
	"./scene/london_ww2.png": "1119",
	"./scene/marypop-bg.png": "2a97",
	"./scene/marypop-fg.png": "8615",
	"./scene/marypop-mg.png": "5f54",
	"./scene/newspaper4.png": "439b",
	"./scene/newspaper4_nohead.png": "d62f",
	"./scene/newspaper4_smallhead copy.png": "d6a5",
	"./scene/newspaper4_smallhead.png": "8a13",
	"./scene/newspaper4_ww2.png": "ff47",
	"./scene/oscilloscope4.png": "8c5a",
	"./scene/panel-record.png": "6b57",
	"./scene/paparazzi-2.png": "51bd",
	"./scene/royal_buildings.png": "1dbb",
	"./scene/royal_sky.png": "868a",
	"./scene/street-panel.png": "6011",
	"./scene/street-panel.psd": "616a",
	"./scene/studio_front.png": "9652",
	"./scene/studio_mid_with_floor.png": "f045",
	"./scene/studio_wall.png": "a9bc",
	"./scene/urban-fence": "057d",
	"./scene/urban-fence.png": "0451",
	"./scene/urban-fence.psd": "3a31",
	"./skip-btn.png": "fee5",
	"./splash.jpg": "b154",
	"./timeline-face-1.png": "b1ba",
	"./timeline-face-2.png": "3e96",
	"./timeline-face-3.png": "b6cf",
	"./timeline-face-4.png": "77c0",
	"./timeline-face-5.png": "0f30",
	"./timeline-face-6.png": "62b5",
	"./timeline-face-7.png": "bfae"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";